// extracted by mini-css-extract-plugin
export var button = "styles-module--button--T+TLO";
export var container = "styles-module--container--sYcBe";
export var form = "styles-module--form--ERqwt";
export var formInput = "styles-module--formInput--XaQ8T";
export var formStatus = "styles-module--formStatus--75kbC";